import React, { useState } from "react";
import "./style.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";

const ReportAndAnalysticsComp = ({
  isLoading = false
}) => {
  const navigate = useNavigate();

  const arrowClick = () => {
    navigate("/");
  };

  return (
    <>
      {isLoading ? (
        <div className="report-analytics-loading-container">
          <div className="report-analytics-loading-spinner"></div>
          <p className="report-analytics-loading-text">Loading...</p>
        </div>
      ) : (
        <div className="report-analytics-main-container">
          <Sidebar />

          <div className="report-analytics-content-wrapper">
            {/* Header Section */}
            <div className="report-analytics-header">
              <img
                onClick={arrowClick}
                className="report-analytics-back-icon"
                src={leftArrow}
                alt="Back"
              />
              <p className="report-analytics-title">Report And Analytics</p>
            </div>

            {/* Coming Soon Card */}
            <div className="report-analytics-coming-soon-container">
              <div className="report-analytics-coming-soon-card">
                <div className="report-analytics-coming-soon-icon-wrapper">
                  <svg 
                    className="report-analytics-coming-soon-icon"
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                    <circle cx="12" cy="12" r="3"/>
                    <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/>
                  </svg>
                </div>
                <h2 className="report-analytics-coming-soon-heading">
                  Coming Soon!
                </h2>
                <p className="report-analytics-coming-soon-subtext">
                  We're working hard to bring you powerful analytics and reporting features.
                </p>
                <p className="report-analytics-coming-soon-description">
                  Stay tuned for detailed insights, charts, and data visualization tools.
                </p>
                <div className="report-analytics-coming-soon-features">
                  <div className="report-analytics-feature-item">
                    <span className="report-analytics-feature-dot"></span>
                    <span>Sales Analytics</span>
                  </div>
                  <div className="report-analytics-feature-item">
                    <span className="report-analytics-feature-dot"></span>
                    <span>Order Reports</span>
                  </div>
                  <div className="report-analytics-feature-item">
                    <span className="report-analytics-feature-dot"></span>
                    <span>Performance Metrics</span>
                  </div>
                  <div className="report-analytics-feature-item">
                    <span className="report-analytics-feature-dot"></span>
                    <span>Export Data</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportAndAnalysticsComp;